import { Component, OnInit } from '@angular/core';
import {SelectablesService} from '../selectables.service'
import { Branch } from '../selectable-schema';



@Component({
	selector: 'app-branch',
	templateUrl: './branch.component.html',
	styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {

	branches: Branch[];
	selected_branch : string;

	constructor( private selectBranchService : SelectablesService) { }

	ngOnInit() {
		this.getAllBranches();
		localStorage.removeItem("form_info");
	};

	getAllBranches(){
		this.selectBranchService.getBranches()
		.subscribe(branches => {
			console.log(branches);
			this.branches = branches;
		});
	};

	selectedBranch(branch: string){
		this.selected_branch = branch;
		this.selectBranchService.getSelectedBranch(branch);
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/branch/branch.component.ts